import { render } from "./ExerciseDetail.vue?vue&type=template&id=40440cb0"
import script from "./ExerciseDetail.vue?vue&type=script&lang=js"
export * from "./ExerciseDetail.vue?vue&type=script&lang=js"

import "./ExerciseDetail.vue?vue&type=style&index=0&id=40440cb0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__